import { render } from "./access-modal.vue?vue&type=template&id=650a23bc&ts=true"
import script from "./access-modal.vue?vue&type=script&lang=ts"
export * from "./access-modal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__